import { updateAttendanceForm } from '@/utils/attendanceFormHelper'

const antecedentesPessoaisStore = {
  namespaced: true,
  state: () => ({
    id: 'antecedentes-pessoais',
    name: 'Antecedentes pessoais',
    opened: true,
    showing: true,
    completed: false,
    multiple: true,
    scopes: ['ATTENDANCE', 'PRE_CONSULTATION', 'SURGERY'],
    value: []
  }),
  mutations: {
    handleProps: (state, { key, value }) => {
      state[key] = value
    },
    handleFields: (state, { key, value }) => {
      state.fields[key] = value
    },
    checkComplete: state => {
      state.completed = state.value && state.value.length > 0
    }
  },
  getters: {},
  actions: {
    handleProps(context, { key, value }) {
      context.commit('handleProps', { key, value })
      context.commit('checkComplete')

      if (
        context?.rootState?.attendance?.attendance?.id &&
        ['showing', 'opened'].includes(key)
      ) {
        const form = context?.rootGetters['attendance/form/getSelectedForm']
        const forms = form.forms
        const index = forms?.findIndex(form => {
          return form.id === context.state.id
        })

        if (index && index !== -1) {
          forms[index][key] = value
          form.forms = forms
          updateAttendanceForm(
            context?.rootState?.attendance?.attendance?.attendance_form?.id,
            { forms: forms }
          )
          context.dispatch(`attendance/form/updateAttendanceForms`, form, {
            root: true
          })
        }
      }
    },
    handleFields(context, { key, value }) {
      context.commit('handleFields', { key, value })
      context.commit('checkComplete')
    }
  }
}

export default antecedentesPessoaisStore
